import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../styles/variables';
import { StreakFireIcon } from '../atoms/icons/streak_fire_icon';
import { StreakFreezeSimpleIcon } from '../atoms/icons/streak_freeze_simple_icon';
export const HeaderStreakBadge = ({ currentStreak, classObject }) => {
    const hasStreak = currentStreak.hasStreak;
    const isUsedFreezeDisplay = currentStreak.isUsedFreezeYesterday && !currentStreak.isFirstDailyCompletion;
    const isFirstDailyCompletion = currentStreak.isFirstDailyCompletion;
    return (React.createElement("div", { className: css(styles.container, classObject) },
        isUsedFreezeDisplay ? (React.createElement(StreakFreezeSimpleIcon, { classObject: styles.icon })) : (React.createElement(StreakFireIcon, { classObject: styles.icon, isActive: isFirstDailyCompletion })),
        React.createElement("div", { className: css(styles.textWrapper, isUsedFreezeDisplay && styles.textWrapperFreeze, isFirstDailyCompletion && styles.textWrapperActive) }, hasStreak ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: css(styles.dayValue) }, currentStreak.streakCount),
            React.createElement("span", { className: css(styles.text) }, "\u65E5\u7D99\u7D9A\u4E2D"))) : (React.createElement("div", { className: css(styles.text) }, "\u4ECA\u65E5\u304B\u3089\u7D9A\u3051\u3088\u3046\uFF01")))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
    },
    icon: {
        width: 22,
        height: 22,
    },
    textWrapper: {
        color: Colors.GrayDarkest,
        fontWeight: 'bold',
    },
    textWrapperActive: {
        color: Colors.Orange,
    },
    textWrapperFreeze: {
        color: Colors.Blue,
    },
    dayValue: {
        fontSize: 15,
        lineHeight: '100%',
    },
    text: {
        fontSize: 14,
        lineHeight: '120%',
        letterSpacing: 0.42,
    },
});
